export default __webpack_public_path__ + "static/media/PenelopeLovelace.22061ef0.png";